import React, { useState, useEffect } from 'react';
import BirthdayCard from './BirthdayCard';
import './BirthdayCard.css';
import './App.css';

const SPREADSHEET_ID = '1aM34inYbqWJk_w0ALfhlLD6Ei4KCtsTggqVLsPPAa6g';
const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const RANGE = 'Cumples!A:E';
const API_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}?key=${API_KEY}`;

const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const calculateAge = (dia, mes, ano) => {
  if (!dia || !mes || !ano) return null;
  const today = new Date();
  const birthDate = new Date(ano, mes - 1, dia);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const BirthdaysPage = () => {
  const [birthdaysByMonth, setBirthdaysByMonth] = useState({});
  const [error, setError] = useState(null);
  const [activeMonth, setActiveMonth] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBirthdays = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(API_URL);
        if (!response.ok) {
          throw new Error('Error al obtener los datos de cumpleaños.');
        }
        const data = await response.json();
        const values = data.values || [];

        // <<-- INICIO DE LA CORRECCIÓN LÓGICA -->>
        const processedData = values.slice(1).map(row => {
          const [nombre, diaStr, mesNombre, anoStr] = row;
          
          // Convertir nombre de mes a número (1-12)
          const mesIndex = MESES.findIndex(m => m.toLowerCase() === (mesNombre || '').toLowerCase());
          const mes = mesIndex !== -1 ? mesIndex + 1 : null;

          const dia = parseInt(diaStr, 10);
          const ano = parseInt(anoStr, 10);

          return {
            nombre,
            dia,
            mes,
            ano,
            nombreMes: MESES[mesIndex],
            edad: calculateAge(dia, mes, ano)
          };
        }).filter(p => p.nombre && !isNaN(p.dia) && p.mes && !isNaN(p.ano));
        // <<-- FIN DE LA CORRECCIÓN LÓGICA -->>

        const groupedByMonth = processedData.reduce((acc, person) => {
          const monthIndex = person.mes - 1;
          if (monthIndex >= 0 && monthIndex < 12) {
            if (!acc[monthIndex]) acc[monthIndex] = [];
            acc[monthIndex].push(person);
          }
          return acc;
        }, {});

        setBirthdaysByMonth(groupedByMonth);

        const currentMonth = new Date().getMonth();
        if (groupedByMonth[currentMonth]) {
          setActiveMonth(currentMonth);
        } else {
          const firstMonthWithData = MESES.findIndex((_, index) => groupedByMonth[index] && groupedByMonth[index].length > 0);
          setActiveMonth(firstMonthWithData);
        }

      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBirthdays();
  }, []);

  return (
    <div className="container" style={{ paddingTop: '2rem' }}>
      <nav className="tabs">
        {MESES.map((mes, index) => (
          <a
            key={mes}
            href={`#${mes}`}
            className={`${activeMonth === index ? 'active' : ''} ${!birthdaysByMonth[index] ? 'disabled' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              if (birthdaysByMonth[index]) {
                setActiveMonth(index);
              }
            }}
          >
            {mes}
          </a>
        ))}
      </nav>

      {isLoading && <p style={{ textAlign: 'center' }}>Cargando cumpleaños...</p>}
      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      
      {!isLoading && !error && (
        <div className="birthday-grid section">
          {activeMonth !== -1 && birthdaysByMonth[activeMonth] ? (
            <div className="card-grid-fixed">
              {birthdaysByMonth[activeMonth].map(person => (
                <BirthdayCard key={person.nombre} person={person} />
              ))}
            </div>
          ) : (
            <p style={{ textAlign: 'center' }}>No hay cumpleaños para mostrar.</p>
          )}
        </div>
      )}

      <style>{`.tabs a.disabled { opacity: 0.4; background-color: #f0f0f0; cursor: not-allowed; }`}</style>
    </div>
  );
};

export default BirthdaysPage;